define([
	"dojo/_base/declare",
	"underscore",
	"csi/reflection",
	"csi/table/New",
	"csi/xml",
	"./main",
	"csi/locale",
	"csi/service/nodeService",
	"csi/action/Controller",
], function(declare,_,reflection, New, xml, Sourcing, locale, {resolveNodesWithDependencies}, Controller) {

	const FACTORY = "Factory";

	const SUPPLIER = "Supplier";

	return declare(New, {
		// Boolean: validation is handled explicitly
		bValidate: false,

		// String[]: URLs of newly created items
		urlNewItems: null,

		// Integer: Counter
		batchQuoteCtr: 0,

		/** Map<cnl, String>: Map to store Factory or Supplier Names*/
		srcUrlNames: {},

		/** List of Supplier or Supplier Factory Nodes */
		sources: null,

		/** Boolean: return whether we are using Supplier Factory Nodes or Supplier Nodes */
		isSupplierFactory: false,

		//Flag to determine if style ColorAllocationStatus = WIP
		isAllocationWIP: false,

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add new url to request
			return this.inherited(arguments, [urlsNew.concat(this.urlNewItems)]);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return this.m_cache.getNodes(this.urlNewItems);
		},

		toWriter: function() {
			// summary: create SupplierItems according to form
			var self = this;
			var fd = this.m_formData;
			var args = arguments;
			var inheritedToWriter = this.getInherited(args);
			var creator = function(supplier) {
				var call = inheritedToWriter.apply(self, args);
				call.addParameter("SrcURL", xml.ATTR_REF, supplier);
				return self.m_urlNode;
			}

			this.urlNewItems = this.createQuotes(creator);
		},

		/**
		 * @override
		 * Request Supplier Factory nodes and add them to cache if factory field exist on form
		 */
		async process() {
			this.isSupplierFactory = this.isCreationLevelSupplierFactory();
			this.sources = this.m_formData.getFieldValue(FACTORY, true) || this.m_formData.getFieldValue(SUPPLIER, true);
			
			if (this.isSupplierFactory) {
				const sources = this.sources;
				const sourcesArray = Array.isArray(sources) ? sources : [sources];
				await resolveNodesWithDependencies(sourcesArray, ["Child:Factory"] , this.m_cache);
				const urlNameMap = {};
				const cache = this.m_cache;
				
				_.each(sourcesArray, function(source) {
					const factoryNode = cache.getNode(cache.getNode(source).Factory);
					urlNameMap[source] = factoryNode.$Name;
				});
				this.srcUrlNames = urlNameMap;
			}

			Controller.prototype.process.call(this);
		},

		createQuotes: function(/*Function*/creator) {
			// summary: create SupplierItems according to form
			this.m_formData.colorSizePairs = this.popupView.getSelectedColorSizePairs();

			const field = this.isSupplierFactory ? this.m_formData.getField(FACTORY) : this.m_formData.getField(SUPPLIER);
			if (this.sources && !_.isArray(this.sources)) {
				this.sources = [this.sources];
			}

			if (!this.isSupplierFactory) {
				this.srcUrlNames = this._getSupplierNames(field, this.sources);
			}

			const self = this;

			var items = _.map(this.srcUrlNames, function(value, key) {
				return self.createSupplierItems(self.m_writer, self.m_formData, creator, key, value);
			});

			return _.flatten(items);
		},

		/**
		 * Create SupplierItems according to form.
		 * @param {Writer} writer
		 * @param {FormData} formData
		 * @param {Function} creator
		 * @param {URL} srcURL
		 * @param {string} supplierName
		 * @return {Array<URL>} - URL's of the newly created SupplierItems
		 */
		createSupplierItems: function(writer, formData, creator, srcURL, supplierName, lineItem = null) {
			// FormData must have 'colorSizePairs' object in the format {c:<color-node>, s:<size-node>}.
			// 'colorSizePairs' can be null if the user choose do not create color/size specific SupplierItem-s
			var colorSizePairs = formData.colorSizePairs;
			var urlNewItems;
			const parentType = this.getParent().$Type;

			if (!colorSizePairs || colorSizePairs.length == 0) {
				colorSizePairs = [{c: null, s: null}];
			}

			const config = reflection.getObject("centric://REFLECTION/INSTANCE/SourcingModule/Configuration");
			const batchSize = config.QuoteCreationBatchSize || 20; // 20 is default

			urlNewItems = colorSizePairs.map(pair => {
				formData.clearUsedFields();

				const names = [supplierName];
				const nameField = formData.getField(xml.ATTR_NAME);
				let name = formData.getFieldValue(xml.ATTR_NAME, true);
				if (name) {
					names.push(name);
				}

				const color = pair.c;
				const size = pair.s;
				const urlNode = creator(srcURL);
				const urlRevision = xml.getUrlPath(urlNode, reflection.PATH_CURRENT_REVISION);
				const cn = writer.changeNode(urlRevision);

				if (color) {
					const quotePerActiveColor = formData.getFieldValue("SupplierItemDimensions") == this.popupView.getQuotePerActiveColor();
					const productNode = this.m_cache.getNode(lineItem?.product);
					const lineItemNode = this.m_cache.getNode(lineItem?.lineitem);
					this.isAllocationWIP = Sourcing.isProductColorwayAllocationWIP(productNode);
					// If product has ColorAllocationStatus = WIP and QuotePerActiveColor option is true
					if(this.isAllocationWIP && quotePerActiveColor) {
						const isSupplierFactory = this.isCreationLevelSupplierFactory();
						const colorExistInColorSources = Sourcing.isColorInColorSources(lineItemNode.$URL, color.$URL, srcURL, isSupplierFactory, this.m_cache)
						// If colorExistInColorSources is true then we will change Color attribute 
						if(colorExistInColorSources) {
							names.push(color.$Name);
							cn.changeAttribute("Colors", xml.ATTR_REFLIST, [color.$URL]);
						} else {
							return writer.deleteNode(urlNode);
						}
					} else {
						names.push(color.$Name);
						cn.changeAttribute("Colors", xml.ATTR_REFLIST, [color.$URL]);
					}
				}

				if (size) {
					names.push(size.$Name);
					cn.changeAttribute("ProductSizes", xml.ATTR_REFLIST, [size.$URL]);
				}

				if (nameField && (!nameField.hasExpression() || !nameField.isDefaultValue())) {
					writer.changeNode(urlNode)
						.changeAttributeFlag(xml.ATTR_NAME, xml.ATTR_FLAG_EVAL_EXPRESSION | xml.ATTR_FLAG_ONE_TIME_EXPRESSION, false, true)
						.changeAttributeExp(xml.ATTR_NAME, "")
						.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, names.join(" - "));
				}
		
				// pull in rest of custom attribute fields on form
				this.toWriterFields(urlNode);
				writer.validateNode(urlNode, true); // done with this node.  ready to validate it.

				// commit in batches of batchSize (default=20) quotes
				this.batchQuoteCtr++;
				if (this.batchQuoteCtr === batchSize) {
					writer.flushChanges();
					this.batchQuoteCtr = 0;
				}

				return urlNode;
			});

			return urlNewItems;
		},

		/**
		 * Get supplier names
		 * @param {Field} field
		 * @param {Array<URL>} suppliers
		 * @return map of {supplier url, supplier name}
		 */
		_getSupplierNames : function(field, suppliers) {
			var urlNameMap = {};

			// Action under ProductSource, no "Supplier" field on the form
			if (!field || _.isEmpty(suppliers)) {
				var parentNode = this.m_cache.getNode(this.m_urlParent);
				if (parentNode && (parentNode.$Type == "ProductSource" || parentNode.$Type == "FoodSource")) {
					var supplier = this.m_cache.getNode(parentNode.Supplier);
					if (supplier) {
						urlNameMap[parentNode.Supplier] = supplier.$Name;
					}
				}
				return urlNameMap;
			}

			var store = field.m_control.get("store");
			if (store) {
				_.each(suppliers, function(supplier) {
					urlNameMap[supplier] = store.get(supplier)[store.labelProperty];
				});
			}

			return urlNameMap;
		},

		/**
		 * @override
		 * populate the popup params - bSupplierRequest and isFDDEnabled to be reuse on SupplierItemForm and FoodSupplierItemForm
		 */
		onCreatePopupParams: function(params) {
			const node = this.getParent();
			const cache = this.m_cache;
			if(node.$Type === "SupplierRequest") {
				params.bSupplierRequest = true;
			}
			params.isFDDEnabled = Sourcing.isFDDEnabled(node, cache);
		},

		/**
		 * Determine whether the field is Factory or not
		 * @return {Boolean}
		 */
		isCreationLevelSupplierFactory() {
			return this.m_formData.getField(FACTORY) != null;
		},

	});
});
